import { Form } from 'react-bootstrap';

import { FISCAL_MONTH_OPTIONS, type FiscalPeriodConfig } from 'utils/fiscalPeriods';

import type { FiscalPeriodPatch } from './shared';

interface Props {
  readonly config: FiscalPeriodConfig;
  readonly startDay: string;
  readonly endDay: string;
  readonly patch: FiscalPeriodPatch;
}

/** Period-start vs year-end definition choice (hidden for iso_week). */
export const DefinedByChoice = ({ config, startDay, endDay, patch }: Props) => {
  if (config.anchor_rule === 'iso_week') {
    return (
      <p className="text-muted small mb-4">
        ISO week already <strong>is</strong> a period-1 rule: period 1 starts on the {startDay} of the week containing the 4th of{' '}
        {FISCAL_MONTH_OPTIONS.find((m) => m.value === config.anchor_month)?.label}. The year ends the previous {endDay}. Year-end vs period-start is a choice
        for the other rules — switch Anchor rule to <em>Nearest to the date</em> (NRF) or <em>Last on or before the date</em> to pick year-end yourself.
      </p>
    );
  }

  return (
    <Form.Group className="mb-4">
      <Form.Label>Define the boundary as</Form.Label>
      <Form.Check
        type="radio"
        id="fiscal-defined-by-year-end"
        name="fiscal-defined-by"
        checked={config.defined_by === 'year_end'}
        onChange={() => patch({ defined_by: 'year_end' })}
        label={
          <span>
            <strong>Year-end</strong> (recommended) — ends on the {endDay} matching the rule above; period 1 is the next day. The 53rd week attaches cleanly to
            the end.
          </span>
        }
      />
      <Form.Check
        type="radio"
        id="fiscal-defined-by-period-start"
        name="fiscal-defined-by"
        className="mt-2"
        checked={config.defined_by === 'period_start'}
        onChange={() => patch({ defined_by: 'period_start' })}
        label={
          <span>
            <strong>Period 1 start</strong> — period 1 starts on the {startDay} matching the rule above.
          </span>
        }
      />
    </Form.Group>
  );
};
